var _excluded = ["fallback", "report"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import Case from 'case';
import React, { isValidElement, forwardRef, Component, useRef, useEffect } from 'react';
import classnames from 'classnames';
import PT from 'prop-types';
import get from 'lodash.get';

/**
 * Transforms a class by adding a value and delimiter to each string separated by a whitespace
 * This is useful for BEM naming when the base name is variable and element/modifiers should be applied to all of them
 * @param {Object} parameters
 * @property {string} className - the list of classes as a single space separated string
 * @property {string} value - the literal you want to add to the classname
 * @property {string} delimiter - the separator between each classname and the value
 * @return {string} - a space separated list of classes, each appended with the delimiter and value
 */
function appendClass(_ref) {
  var className = _ref.className,
    value = _ref.value,
    delimiter = _ref.delimiter;
  if (typeof className !== 'string') {
    throw new TypeError('className must be a string');
  }
  if (typeof value !== 'string') {
    throw new TypeError('value must be a string');
  }
  if (typeof delimiter !== 'string') {
    throw new TypeError('delimiter must be a string');
  }
  return className.split(' ').filter(function (klass) {
    return !!klass;
  }).map(function (klass) {
    return "".concat(klass).concat(delimiter).concat(value);
  }).join(' ');
}

/**
 * Creates an immutable object to hold a constants enum.
 * Variables initializing enums should be in PascalCase.
 * @param {object|string[]} data - values to be create the immutable constant object
 * @returns {object|Proxy} - the immutable object or a Proxy which provides debugging info
 *                         - values will be transformed to SCREAMING_SNAKE case to represent constants
 * @property {object.getAll} - method added to the enum which will return all values of the enum
 *                           - useful for `oneOf` propType declarations or Array.includes functions
 */
function createEnum(data) {
  var newEnum = {};
  if (Array.isArray(data)) {
    data.forEach(function (datum) {
      if (typeof datum !== 'string') {
        throw new TypeError('All enum array values must be strings');
      }
      newEnum[Case.constant(datum)] = datum;
    });
  } else if (data !== null && _typeof(data) === 'object') {
    newEnum = Object.entries(data).reduce(function (formatted, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];
      formatted[Case.constant(k)] = v; // eslint-disable-line no-param-reassign
      return formatted;
    }, {});
  } else {
    throw new TypeError('Data must be an object or an array to create an enum');
  }
  Object.defineProperty(newEnum, 'getAll', {
    value: function value() {
      return Object.values(newEnum);
    }
  });
  if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.Proxy) {
    return new Proxy(newEnum, {
      // trap to provide debugging info for development
      get: function get(target, name) {
        // TODO This is a sticking plaster to stop these errors confusing users at a time when there's bigger errors out there
        // Somehow changing ExpandableTable to be sortable in the docs triggers a lot of symbols and other none ENUMs to be sent to this function.
        // Doesn't happen if the table is set to be sortable on load
        // https://elsevier.atlassian.net/browse/STYLE-902
        /* istanbul ignore next */
        if (_typeof(name) === 'symbol') {
          console.error('name is a symbol, not an enum key.'); // eslint-disable-line no-console
          return undefined;
        }
        /* istanbul ignore next */
        if (name.indexOf('$$') === 0 || name.indexOf('@@') === 0) {
          return undefined;
        }
        if (name === 'getAll') {
          return target.getAll;
        }
        if (!(Case.constant(name) in target)) {
          console.error("`".concat(name, "` is not an enum key.")); // eslint-disable-line no-console
          return undefined;
        }
        return target[Case.constant(name)];
      },
      // trap to prevent addition and/or mutation of object properties
      set: function set(target, name) {
        // eslint-disable-next-line no-console
        console.error("Attempted to set new value for enum key `".concat(name, "`."));
        return false;
      }
    });
  }
  return Object.freeze(newEnum);
}
var ValidPropTypes = createEnum(['array', 'bool', 'function', 'node', 'number', 'object', 'string']);

/**
 * Determines whether prop key of props is undefined or not
 * @param {String} propName key of prop
 * @param {Object} props object of component props
 * @returns {Boolean}
 */
var checkIsUndefined = function checkIsUndefined(propName, props) {
  var prop = props[propName];
  return prop === undefined;
};

/**
 * Determines whether prop key of props is the correct type
 * @param {String} propName key of prop
 * @param {Object} props object of component props
 * @param {String} type a value from ValidPropTypes
 * @returns {Boolean}
 */
var checkIsInvalidType = function checkIsInvalidType(propName, props, type) {
  var prop = props[propName];
  var isInvalidType = false;

  // eslint-disable-next-line default-case
  switch (type) {
    case ValidPropTypes.ARRAY:
      isInvalidType = !Array.isArray(prop);
      break;
    case ValidPropTypes.BOOL:
      isInvalidType = prop !== !!prop;
      break;
    case ValidPropTypes.FUNCTION:
      isInvalidType = typeof prop !== 'function';
      break;
    case ValidPropTypes.NODE:
      // This doesn't have to be specifically a react element, it can be any `renderable` type
      isInvalidType = Array.isArray(prop) ? !prop.every(function (p) {
        return !p ||
        // falsy
        isValidElement(p) ||
        // valid react element
        typeof p === 'string' ||
        // string
        typeof p === 'number';
      } // number
      ) : !(!prop || isValidElement(prop) || typeof prop === 'string' || typeof prop === 'number');
      break;
    case ValidPropTypes.NUMBER:
      isInvalidType = typeof prop !== 'number';
      break;
    case ValidPropTypes.OBJECT:
      isInvalidType = _typeof(prop) !== 'object';
      break;
    case ValidPropTypes.STRING:
      isInvalidType = typeof prop !== 'string';
      break;
  }
  return isInvalidType;
};

/**
 * Does a recursive check of the requiredProps object to make sure all props are not undefined and are the correct type
 * @param {Object} requiredProps object of prop key/type pairs to be checked
 * @param {Object} props the props object from the component being checked
 * @param {String} propKey string key to use when accessing nested values inside of props
 */
var propCheck = function propCheck(requiredProps, props, propKey) {
  // lodash.get does a deep retrieval of a specified key and returns its value or the fallback value if the key is not found
  // See https://lodash.com/docs/4.17.15#get
  var propsToUse = propKey ? get(props, propKey, {}) : props;
  var requiredPropsToUse = propKey ? get(requiredProps, propKey, {}) : requiredProps;
  Object.entries(requiredPropsToUse).forEach(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      propName = _ref5[0],
      requiredPropType = _ref5[1];
    if (!ValidPropTypes.getAll().includes(requiredPropType) && _typeof(requiredPropType) !== 'object') {
      var pathPrefix = propKey ? "".concat(propKey, ".") : '';
      var propPath = "".concat(pathPrefix).concat(propName);
      throw new TypeError("".concat(propPath, " property of requiredProps is not a valid type"));
    }
    if (_typeof(requiredPropType) === 'object' && !Array.isArray(requiredPropType)) {
      propCheck(requiredProps, props, "".concat(propKey ? "".concat(propKey, ".") : '').concat(propName));
    } else {
      var propIsUndefined = checkIsUndefined(propName, propsToUse);
      var propIsInvalidType = checkIsInvalidType(propName, propsToUse, requiredPropsToUse[propName]);
      var _pathPrefix = propKey ? "".concat(propKey, ".") : '';
      var _propPath = "".concat(_pathPrefix).concat(propName);
      if (propIsUndefined) {
        throw new TypeError("Required prop '".concat(_propPath, "' is undefined"));
      }
      if (propIsInvalidType) {
        throw new TypeError("Required prop '".concat(_propPath, "' is incorrect type"));
      }
    }
  });
};

/**
 * This function takes the component to be rendered and
 * @param {ReactElement} renderedComponent The React component being checked for requiredProps
 */
function validateRequiredProps(renderedComponent) {
  var props = renderedComponent.props,
    requiredProps = renderedComponent.type.requiredProps;
  if (requiredProps) {
    if (_typeof(requiredProps) !== 'object') {
      throw new TypeError('requiredProps must be an object');
    }
    propCheck(requiredProps, props);
    return renderedComponent;
  }
  throw new TypeError("Component's requiredProps property must be defined");
}
var func = PT.func,
  node$1 = PT.node,
  string$1 = PT.string;
var ValidatedChildComponent = forwardRef(function (ChildElement, ref) {
  return (
    // ChildElement.type is a reference to the underlying component class/function that is being rendered
    // This is critical to the whole requiredProps mechanism working as it is how the validate function can
    // get the requiredProps from the component being rendered
    validateRequiredProps(
    // eslint-disable-next-line react/jsx-pascal-case
    /* @__PURE__ */
    React.createElement(ChildElement.type, _objectSpread(_objectSpread({}, ChildElement.props), {}, {
      ref: ref
    })))
  );
});
ValidatedChildComponent.displayName = "ValidatedChildComponent";
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorBoundary, [].concat(args));
    _defineProperty(_this, "state", {
      error: null,
      hasError: false
    });
    return _this;
  }
  _inherits(ErrorBoundary, _Component);
  return _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      var report = this.props.report;
      if (report) {
        report(error, info);
      } else {
        console.error("Error Boundary: ", info.componentStack);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        fallback = _this$props.fallback;
      var _this$state = this.state,
        hasError = _this$state.hasError,
        error = _this$state.error;
      var defaultErrorStyle = {
        border: "1px solid #c83727",
        color: "#c83727",
        padding: "0.5rem"
      };
      var classes = classnames("error-boundary", "error-boundary--has-error", className);
      if (hasError) {
        return fallback ? fallback(error, classes) : /* @__PURE__ */React.createElement("div", {
          style: defaultErrorStyle,
          className: classes,
          "data-testid": "error-container"
        }, /* @__PURE__ */React.createElement("span", {
          className: "error-boundary__message",
          "data-testid": "error-boundary-message"
        }, "Error Boundary: ", error.message));
      }
      return /* @__PURE__ */React.createElement(ValidatedChildComponent, _objectSpread({}, children));
    }
  }]);
}(Component);
ErrorBoundary.getDerivedStateFromError = function (error) {
  return {
    error: error,
    hasError: true
  };
};
ErrorBoundary.propTypes = {
  /** The render tree to catch errors from */
  children: node$1.isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$1,
  /**
   * Custom render function if an error is encountered
   * @param {Error} error - Error object that was thrown
   * @param {String} classes - error boundary classes to render on the fallback component
   */
  fallback: func,
  /** Custom function to handle reporting of encountered errors
   * @param {Error} error - Error object that was thrown
   * @param {Object} info - Information about error
   * @property {string} info.componentStack - Stack trace from error
   */
  report: func
};
ErrorBoundary.defaultProps = {
  className: "",
  fallback: null,
  report: null
};
var makeErrorBoundComponent = function makeErrorBoundComponent(Component) {
  var name = Component.displayName || "Component";
  var errorBoundComponent = forwardRef(
  // eslint-disable-next-line react/prop-types
  function (_ref6, ref) {
    var fallback = _ref6.fallback,
      report = _ref6.report,
      props = _objectWithoutProperties(_ref6, _excluded);
    return /* @__PURE__ */React.createElement(ErrorBoundary, {
      className: "error-boundary--".concat(name.toLowerCase()),
      fallback: fallback,
      report: report
    }, /* @__PURE__ */React.createElement(Component, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    })));
  });
  Object.entries(Component).forEach(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      propertyName = _ref8[0],
      propertyValue = _ref8[1];
    errorBoundComponent[propertyName] = propertyValue;
  });
  errorBoundComponent.displayName = "ErrorBound".concat(name);
  return errorBoundComponent;
};

/**
 * Formats a file size string in bytes to the most fitting file size (KB, MB, etc)
 * @param {Number} fileSizeBytes file size in bytes
 * @returns {String} file size string in most fitting unit of measurement
 */
function formatFileSize(fileSizeBytes) {
  var formattedFileSize = "".concat(fileSizeBytes, " bytes");
  if (fileSizeBytes >= 1000) {
    formattedFileSize = "".concat(fileSizeBytes / 1000, " KB");
  }
  if (fileSizeBytes >= 1000000) {
    formattedFileSize = "".concat(fileSizeBytes / 1000000, " MB");
  }
  if (fileSizeBytes >= 1000000000) {
    formattedFileSize = "".concat(fileSizeBytes / 1000000000, " GB");
  }
  return formattedFileSize;
}

/**
 * Creates a 5 character random string.
 *
 * If using this to generate a static ID for a component, initializing
 * a static ID property in component state allows for the component to
 * have a consistent ID that won't change as it updates
 */
function generateId() {
  return (Math.random() + 1).toString(36).substr(2, 5);
}
var number = PT.number;
var GlobalFocusOffset = function GlobalFocusOffset(_ref9) {
  var topOffset = _ref9.topOffset;
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Tab') {
      var focussedElement = document.activeElement;
      var elementPosition = focussedElement.getBoundingClientRect();

      // If top position less than offset, scroll up by the difference
      if (elementPosition.top < topOffset) {
        window.scrollBy(0, elementPosition.top - topOffset);
      }
    }
  });
  return null;
};
GlobalFocusOffset.propTypes = {
  /** Amount of top offset focussed item should have. Typically the height of a fixed header. */
  topOffset: number.isRequired
};
GlobalFocusOffset.requiredProps = {
  topOffset: ValidPropTypes.NUMBER
};
var node = PT.node,
  string = PT.string;

/**
 * Component which initializes focus hiding for mouse users.
 * This only needs to be used once per render tree, and normally
 * is added around the top level app component and scoped to the body.
 */
var GlobalFocusToggle = function GlobalFocusToggle(_ref10) {
  var children = _ref10.children,
    selector = _ref10.selector;
  var element = document.querySelector(selector);

  // Don't do anything if invalid selector is supplied
  if (!element) return children;
  element.classList.add('s-els-no-focus');
  document.addEventListener('mousedown', function () {
    element.classList.add('s-els-no-focus');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      element.classList.remove('s-els-no-focus');
    }
  });
  return children;
};
GlobalFocusToggle.propTypes = {
  /** Render tree that should have its focus controlled by the toggle */
  children: node.isRequired,
  /** Selects element above render tree which should get the class which controls focus */
  selector: string
};
GlobalFocusToggle.requiredProps = {
  children: ValidPropTypes.NODE
};
GlobalFocusToggle.defaultProps = {
  selector: 'body'
};

/* istanbul ignore next */
/**
 * Custom hook to setup and cleanup event listeners
 * @param {string} eventName - type of event (keydown, click, etc)
 * @param {function} handler - the callback to execute on the event
 * @param {object} element - a ref object or DOM object, probably from ref.current
 */

var useEventListener = function useEventListener(eventName, handler, element) {
  // Create a ref that stores handler
  var savedHandler = useRef();

  // Update ref.current value if handler changes.
  // This allows our effect below to always get latest handler ...
  // ... without us needing to pass it in effect deps array ...
  // ... and potentially cause effect to re-run every render.
  useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(function () {
    var target = element;
    if (typeof element === 'undefined') {
      /**
       * SSR Compatibility
       * `window` cannot be declared as a default value for
       * `element` as it can only be guaranteed in useEffect.
       */
      target = window;
    }
    var isSupported = target && target.addEventListener;
    if (!isSupported) {
      return;
    }

    // Create event listener that calls handler function stored in ref
    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    // Add event listener
    target.addEventListener(eventName, eventListener);

    // Remove event listener on cleanup
    // eslint-disable-next-line consistent-return
    return function () {
      target.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element] // Re-run if eventName or element changes
  );
};
export { ErrorBoundary, GlobalFocusOffset, GlobalFocusToggle, ValidPropTypes, appendClass, createEnum, formatFileSize, generateId, makeErrorBoundComponent, useEventListener, validateRequiredProps };
